// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6OdZ-","question":"styles_question__1mgDi","description":"styles_description__3Vc5y"};